export var PERMISSION_STATUS;
(function (PERMISSION_STATUS) {
    PERMISSION_STATUS["GRANTED"] = "granted";
    PERMISSION_STATUS["DENIED"] = "denied";
    PERMISSION_STATUS["DEFAULT"] = "default";
})(PERMISSION_STATUS || (PERMISSION_STATUS = {}));
export var TRACK_EVENTS;
(function (TRACK_EVENTS) {
    TRACK_EVENTS["NOTIFICATION_PUSH_CLOSE"] = "notification_push_close";
    TRACK_EVENTS["NOTIFICATION_PUSH_CANCEL"] = "notification_push_cancel";
    TRACK_EVENTS["NOTIFICATION_PUSH_OPT_IN"] = "notification_push_optIn";
    TRACK_EVENTS["NOTIFICATION_PUSH_BLOCKED_CLOSE"] = "notification_push_blockedClose";
})(TRACK_EVENTS || (TRACK_EVENTS = {}));
//# sourceMappingURL=types.js.map